var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import { t } from 'i18next';
import { IntegrationType, PlanType, PlanTypeCategory } from '../../enum';
import { formatIntegrationTypeLabel } from '../../util';
export var ImportDataType;
(function (ImportDataType) {
  ImportDataType["None"] = "none";
  ImportDataType["Excel"] = "excel";
  ImportDataType["GenesysForecast"] = "genesys";
  ImportDataType["AspectForecast"] = "aspect";
})(ImportDataType || (ImportDataType = {}));
export var getPlanTypeOptions = function () {
  return [{
    value: PlanType.Monthly,
    name: t('Monthly', {
      ns: 'translation',
      defaultValue: 'Monthly'
    })
  }, {
    value: PlanType.Weekly,
    name: t('Weekly', {
      ns: 'translation',
      defaultValue: 'Weekly'
    })
  }];
};
export var getPlanTypeCategoryOptions = function () {
  return [{
    value: PlanTypeCategory.WorkVolume,
    name: t('planTypeCategoryOptions.workVolume', {
      ns: 'myPlans',
      defaultValue: 'Work Volume'
    })
  }, {
    value: PlanTypeCategory.ProdHours,
    name: t('planTypeCategoryOptions.prodHours', {
      ns: 'myPlans',
      defaultValue: 'Production / Productive Hours'
    })
  }];
};
export var getBaseImportDataTypeOptions = function () {
  return [{
    id: ImportDataType.None,
    name: t('importSelect.none', {
      ns: 'myPlans',
      defaultValue: 'None'
    })
  }, {
    id: ImportDataType.Excel,
    name: t('importSelect.excelTemplate', {
      ns: 'myPlans',
      defaultValue: 'Excel Template'
    })
  }];
};
export var integrationTypeToImportDataType = (_a = {}, _a[IntegrationType.Genesys] = ImportDataType.GenesysForecast, _a[IntegrationType.Aspect] = ImportDataType.AspectForecast, _a);
// Embedded integrations (genesys-ui) keep the legacy bare-type id — that path has no named
// connections, so its options stay byte-identical to before.
export var getImportOptionForIntegration = function (integration) {
  return {
    id: integrationTypeToImportDataType[integration.type],
    name: t("importSelect.".concat(integration.type, "Forecast"), {
      ns: 'myPlans',
      defaultValue: integration.name
    }),
    integrationType: integration.type,
    isActive: integration.isActive !== false
  };
};
export var getImportDataTypeOptions = function (availableIntegrations) {
  if (availableIntegrations === void 0) {
    availableIntegrations = [];
  }
  var baseOptions = getBaseImportDataTypeOptions();
  var integrationOptions = availableIntegrations.map(getImportOptionForIntegration);
  return __spreadArray(__spreadArray([], baseOptions, true), integrationOptions, true);
};
/** Stable option id for a named client connection, e.g. "aspect-42". */
export var connectionOptionId = function (type, integrationId) {
  return "".concat(type, "-").concat(integrationId);
};
// A named client connection ("Aspect UK") becomes one dropdown option keyed by its integration id, so
// multiple connections of the same type each get a distinct, individually-selectable entry.
export var getImportOptionForConnection = function (connection) {
  return {
    id: connectionOptionId(connection.type, connection.id),
    name: t('importSelect.integrationConnection', {
      ns: 'myPlans',
      integration: formatIntegrationTypeLabel(connection.type),
      name: connection.name,
      defaultValue: "".concat(formatIntegrationTypeLabel(connection.type), " ").concat(connection.name)
    }),
    integrationType: connection.type,
    integrationId: connection.id,
    isActive: !connection.isExpired
  };
};
export var getConnectionImportOptions = function (connections) {
  if (connections === void 0) {
    connections = [];
  }
  return __spreadArray(__spreadArray([], getBaseImportDataTypeOptions(), true), connections.map(getImportOptionForConnection), true);
};
export var isForecastImport = function (option) {
  return !!(option === null || option === void 0 ? void 0 : option.integrationType);
};
export var getIntegrationTypeFromImportType = function (option) {
  return option === null || option === void 0 ? void 0 : option.integrationType;
};
// Derive the integration type straight from an option id (bare "aspect" for embedded, or the
// "aspect-42" connection form). Used where only the id string is available (e.g. the import dialog's
// fallback when planFormData carries no explicit integrationType).
export var getIntegrationTypeFromOptionId = function (id) {
  var typePart = id === null || id === void 0 ? void 0 : id.split('-')[0];
  if (typePart === IntegrationType.Genesys) return IntegrationType.Genesys;
  if (typePart === IntegrationType.Aspect) return IntegrationType.Aspect;
  return undefined;
};
export var MAX_PERIOD_LENGTH = (_b = {}, _b[PlanType.Monthly] = 36, _b[PlanType.MonthlyCustom] = 36, _b[PlanType.Weekly] = 52, _b);
export var ANNUAL_PERIOD_LENGTH = new Set([12, 24, 36]);
export var MAX_FILE_SIZE = 10485760; // 10MB
export var MONTHLY_PLAN_TYPES = [PlanType.Monthly, PlanType.MonthlyCustom];